import React, { useEffect } from 'react';
import './Home.css';
import { prefetchFuncAreas, prefetchTrngCourses } from './cache';
import { prefetchDistinctFilters } from '../Components/Menu/Branch';

function Home() {
  useEffect(() => {
    prefetchFuncAreas();
    prefetchTrngCourses();
    prefetchDistinctFilters();
  }, []);

  return (
    <div className='HomeBody'>
      <p>Login Successful.</p>
      <p>Please select desired option.</p>
    </div>
  );
}

export default Home;
